module.exports = __webpack_public_path__ + "media/images/teams/logo__12-11403b540360347a604ccf22629ed090.svg";